import type { PaletteOptions } from '@mui/material/styles';

import { tokens } from './tokens';

const { color } = tokens;

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: color.brand[500],
    light: color.brand[300],
    dark: color.brand[700],
    contrastText: '#ffffff',
  },
  secondary: {
    main: color.neutral[600],
    light: color.neutral[400],
    dark: color.neutral[800],
    contrastText: '#ffffff',
  },
  success: color.success,
  warning: color.warning,
  error: color.error,
  info: color.info,
  background: {
    default: color.surface.canvas,
    paper: color.neutral[0],
  },
  text: {
    primary: color.neutral[900],
    secondary: color.neutral[500],
    disabled: color.neutral[400],
  },
  divider: color.neutral[200],
  action: {
    hover: 'rgba(45, 106, 106, 0.06)',
    selected: 'rgba(45, 106, 106, 0.12)',
    focus: 'rgba(45, 106, 106, 0.1)',
  },
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: color.brand[300],
    light: color.brand[200],
    dark: color.brand[500],
    contrastText: '#0f1212',
  },
  secondary: {
    main: color.brand[200],
    light: color.brand[100],
    dark: color.brand[400],
    contrastText: color.neutral[900],
  },
  success: {
    main: '#4ade80',
    light: '#86efac',
    dark: '#22c55e',
    contrastText: '#0f1212',
  },
  warning: {
    main: '#fbbf24',
    light: '#fde047',
    dark: '#d97706',
    contrastText: '#0f1212',
  },
  error: {
    main: '#f87171',
    light: '#fca5a5',
    dark: '#ef4444',
    contrastText: '#0f1212',
  },
  info: {
    main: color.brand[300],
    light: color.brand[200],
    dark: color.brand[500],
    contrastText: '#0f1212',
  },
  background: {
    default: color.surface.darkCanvas,
    paper: color.surface.darkPaper,
  },
  text: {
    primary: color.text.darkPrimary,
    secondary: color.text.darkSecondary,
    disabled: color.text.darkDisabled,
  },
  divider: color.surface.darkBorder,
  action: {
    hover: 'rgba(255, 255, 255, 0.06)',
    selected: 'rgba(126, 186, 186, 0.2)',
    focus: 'rgba(126, 186, 186, 0.16)',
    disabled: 'rgba(244, 248, 247, 0.35)',
    disabledBackground: 'rgba(244, 248, 247, 0.08)',
  },
};
